import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import { loginWithTwitch, loginWithYoutube } from '../InternetAccounts/Utils'
import { login, verify } from '../../Utils/Authentication'
import { GreenButton, GreyButton, DarkButton } from '../SpiceUI/MUI';
import Button from '@mui/material/Button'

import { FaTwitch } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";

export function LoginBanner( props )
{
    const navigate = useNavigate()

    return (
        <div
                style={{
                width: '400px', height: '200px', backgroundColor: 'white', 
                padding:'10px', borderRadius: '10px'
        }}>
            <p style={{fontSize:'25px',color:'#5C9286',marginBottom:'10px'}}>Spice Up Your Stream</p>
            <p style={{margin:'0px'}} >Using AI, we create smart stream widgets that</p>
            <p style={{margin:'0px'}}>are aware of and react to the stream content.</p>
            <p>Login to join our <b>early access</b> program.</p>
            <div>
                <GreenButton onClick={e => navigate("/login")} 
                        style={{ width: '220px' }}>
                    Join our early access
                </GreenButton>
            </div>
        </div>
    )
}

export function LoginModule( props )
{
    const destination = props.to

    const [username, setUsername] = useState(null)
    const [password, setPassword] = useState(null)
    const [hasError, setHasError] = useState(false)
    let navigate = useNavigate()

    const loginButton = () => {
        if (username !== null && password !== null) {
            login({ username, password }).then(success => {
                if (success) {
                    setHasError(false)
                    navigate(destination)
                }
                else {
                    setHasError(true)
                }
            })
        }
    }

    return (
        <div className="d-flex justify-content-center align-items-center" 
             style={{ width: '100%', height: '100vh' }}>
            <div style={{ width: '360px', height: '320px',
                          borderRadius: '10px', 
                          padding: '20px'
            }}>
                <div style={{ width:'100%', height:'100px'}}>
                    <img src={'/images/logo-motion-0205_1.gif'} 
                         style={{ width:'auto', height:'80%' }}  
                    />
                </div>

                {/*<p style={{ color: '#5D9386', fontSize: '20px', FontWeight: 400 }}>Spice.Stream</p>*/}
                <div style={{ padding: 30, marginTop:'-30px' }}>
                    <Form.Control className="my-2"
                                  type="text"
                                  name="username"
                                  placeholder="Username"
                                  value={username}
                                  onChange={e => {
                                    //setHasError( false )
                                    setUsername(e.target.value)
                                  }} 
                    />
                    <Form.Control className="my-2"
                                  type="password"
                                  name="password"
                                  placeholder="Password"
                                  value={password}
                                  onChange={e => {
                                  //setHasError( false )
                                    setPassword(e.target.value)
                                  }} 
                    />
                    <DarkButton variant="contained" 
                                onClick={loginButton} 
                                style={{ width: '100%', boxShadow:'none', marginBottom:'5px',
                                         textTransform:'none'}}>
                        Login
                    </DarkButton>
                    <Button style={{ width:'100%', fontSize:16,color:'#808080', textTransform:'none' }}  
                            onClick={ e => loginWithTwitch("login") }
                    >
                        <FaTwitch style={{ color:'#6441a5', marginRight:'5px', fontSize:20, marginBottom:'5px' }}/>Log in with Twitch
                    </Button>
                    <Button style={{ width:'100%', fontSize:16,color:'#808080', textTransform:'none' }}  
                            onClick={ e => loginWithYoutube("login") }
                    >
                        <FaYoutube style={{ color:'#FF0000', marginRight:'5px', fontSize:20 }}/>Log in with Youtube
                    </Button>
                </div>

            </div>
        </div>
    )
}

export default function Login(props) 
{
    const [ shouldLogin, setShouldLogin ] = useState( false )
    
    if( !shouldLogin )
    {
        return (
            <LoginBanner />
        )
    }


    return (
        <LoginModule />
    )
}

